(function() {
  "use strict";

  angular.module("emails").controller("CampaignController", CampaignController);
  CampaignController.$inject = [
    "$state",
    "$stateParams",
    "CampaignsService",
    "AudienceService",
    "$scope",
    "$timeout",
    "ExpoService",
    "CitiesByExpoService",
    "TimezoneService",
    "$uibModal",
    "$q",
    "mode",
    "chooseType"
  ];

  function CampaignController(
    $state,
    $stateParams,
    CampaignsService,
    AudienceService,
    $scope,
    $timeout,
    ExpoService,
    CitiesByExpoService,
    TimezoneService,
    $uibModal,
    $q,
    mode,
    chooseType
  ) {
    var vm = this;
    vm.stepCurrent = 0;
    vm.mode = mode;
    vm.chooseType = chooseType;
    vm.tab = "variables";
    vm.edit = false;
    vm.ckeditorOptions = {
      language: "en",
      allowedContent: true,
      entities: false
    };
    vm.query = {};
    vm.campaignName = [];
    vm.emailSubject = [];
    vm.fromName = "The Student World";
    vm.fromEmail = "hello@thestudent.world";
    vm.replyToEmail = "no-reply@thestudent.world";
    vm.categoryList = [
      {
        name: "Events (Physical and Online)",
        id: 2
      },
      {
        name: "General News",
        id: 3
      },
      {
        name: "School and Partner Promotions",
        id: 1
      }
    ];
    vm.categorySelected = "";
    vm.campaignAssociatedList = [
      {
        name: "Physical Fair",
        id: 1,
        alias: "physical_fair"
      },
      {
        name: "Virtual Fair",
        id: 2,
        alias: "virtual_fair"
      },
      {
        name: "Webinars",
        id: 3,
        alias: "webinars"
      },
      {
        name: "Private Seminar",
        id: 4,
        alias: "private_seminar"
      }
    ];
    vm.campaignAssociatedSelected = {
      id: 0,
      alias: ""
    };
    vm.tourList = [];
    vm.tourSelected = "";
    vm.tourCityList = [];
    vm.tourCitySelected = "";
    vm.timezoneList = [];
    vm.timezoneSelected = "";

    vm.datePicker = {
      autoApply: true
    };
    vm.userEmail = "";
    vm.templateEmail = "";
    vm.countryList = [];
    vm.audienceSelected = "";
    vm.audienceList = [];
    vm.stateAssociated = false;
    vm.stateCampaignList = false;
    vm.stateCampaignCreate = false;
    vm.stateScheduleCampaign = false;
    vm.sendDate = "";
    vm.sendDateOptions = {
      autoUpdateInput: true,
      autoApply: true,
      singleDatePicker: true,
      timePicker: true,
      timePickerIncrement: 30,
      locale: {
        format: "MM/DD/YYYY h:mm A",
        cancelLabel: "Close"
      }
    };
    vm.stateSendNowCampaign = false;
    vm.scheduleRequired = false;
    vm.replicate = false;
    vm.selectAudience = selectAudience;
    vm.tabChange = tabChange;
    vm.toggleState = toggleState;
    vm.saveCampaign = saveCampaign;
    vm.updateCampaign = updateCampaign;
    vm.queryPrepare = queryPrepare;
    vm.typeOfAction = typeOfAction;
    vm.scheduleButtonToggle = scheduleButtonToggle;
    vm.confirmation = confirmation;
    vm.fillForm = fillForm;

    vm.selectTour = selectTour;
    vm.selectPhysicalFair = selectPhysicalFair;
    vm.selectVirtualFair = selectVirtualFair;
    vm.selectTourCity = selectTourCity;
    vm.selectTimezone = selectTimezone;
    vm.saveDraft = saveDraft;
    vm.updateDraft = updateDraft;
    vm.getTswUrl = getTswUrl;

    /*PAGINATION*/
    vm.pageChanged = pageChanged;
    vm.setPage = setPage;
    vm.totalItems = [];
    vm.to = [];
    vm.currentPage = null;
    vm.itemsPerPage = [];
    vm.page = 1;
    vm.tswUrl = '';

    function activate() {
      vm.tswUrl = vm.getTswUrl();
      vm.audienceRoute = "root.emails.campaignEmail.create";
      if (vm.chooseType === "sms") {
        vm.audienceRoute = "root.emails.campaignSms.create";
      }
      $scope.$on("SaveAudience", function(evt, args) {
        vm.selectAudience();
        vm.stateCampaignCreate = false;
        vm.stateCampaignList = true;
        $timeout(function() {
          vm.audienceSelected = args.message;
        }, 0);
      });
      if ($stateParams.CampaignId) {
        vm.fillForm($stateParams.CampaignId);
      }
      vm.selectAudience();
      vm.selectTimezone();
    }

    function selectAudience() {
      var defer = $q.defer();
      AudienceService.getAudience()
        .then(function(response) {
          vm.audienceList = response.data;
          defer.resolve(response.data);
        })
        .catch(function(err) {
          defer.resolve(err);
        });
      return defer.promise;
    }

    function toggleState(type) {
      if (type == "create") {
        vm.stateCampaignCreate = true;
        vm.stateCampaignList = false;
      } else {
        vm.stateCampaignCreate = false;
        vm.stateCampaignList = true;
      }
    }

    function saveCampaign() {
      /* STUDENTS -> USER */
      vm.queryPrepare(false);
      CampaignsService.saveCampaign(vm.query)
        .then(function(response) {
          vm.countFilter = response.data;
          $state.go("root.emails.campaignList");
        })
        .catch(function(err) {});
    }

    function tabChange(value) {
      vm.tab = value;
    }

    function queryPrepare(draft) {
      if (typeof vm.campaignName !== "undefined") {
        vm.query["title"] = vm.campaignName;
      }
      if (typeof vm.campaignName !== "undefined") {
        vm.query["title"] = vm.campaignName;
      }
      if (typeof vm.categorySelected !== "undefined") {
        vm.query["adm_email_category_id"] = vm.categorySelected.id;
      }
      if (typeof vm.emailSubject !== "undefined" && vm.chooseType !== "sms") {
        vm.query["subject"] = vm.emailSubject;
      }
      if (typeof vm.fromName !== "undefined" && vm.chooseType !== "sms") {
        vm.query["from_name"] = vm.fromName;
      }
      if (typeof vm.fromEmail !== "undefined" && vm.chooseType !== "sms") {
        vm.query["from"] = vm.fromEmail;
      }
      if (typeof vm.replyToEmail !== "undefined" && vm.chooseType !== "sms") {
        vm.query["reply_to"] = vm.replyToEmail;
      }
      if (typeof vm.campaignAssociatedSelected !== "undefined") {
        vm.query["campaign_associated_with"] =
          vm.campaignAssociatedSelected.alias;
      }
      if (typeof vm.tourSelected !== "undefined") {
        vm.query["tour_id"] = vm.tourSelected.id;
      }
      if (typeof vm.tourCitySelected !== "undefined") {
        vm.query["tour_city_id"] = vm.tourCitySelected.id;
      }
      if (typeof vm.templateEmail !== "undefined") {
        const regEx = "/https://edufindme.com/emails/cancel/%7Bemail_token%7D/";
        vm.templateEmail.replace(
          regEx,
          "https://edufindme.com/emails/cancel/{email_token}"
        );
        vm.query["template"] = vm.templateEmail;
      }
      if (typeof vm.audienceSelected !== "undefined") {
        vm.query["audience_id"] = vm.audienceSelected.id;
        vm.query["total_audience"] =
          vm.chooseType !== "sms"
            ? vm.audienceSelected.total_audience
            : vm.audienceSelected.total_audience_sms;
      }
      vm.query["campaign_type"] = vm.chooseType;
      if (draft !== true) {
        if (typeof vm.sendDate !== "undefined") {
          vm.query["send_at"] = vm.sendDate;
        } else {
          vm.query["send_at"] = moment()
            .utc()
            .format("YYYY-MM-DD HH:mm:ss");
        }

        vm.query["status"] = "Released";
        if (typeof vm.timezoneSelected !== "undefined") {
          vm.query["timezone"] = vm.timezoneSelected.timezone_name;
        }
      } else {
        vm.query["send_at"] = "";
        vm.query["status"] = "Draft";
        vm.query["timezone"] = "";
      }
      if ($stateParams.CampaignId && vm.mode === "edit") {
        vm.query["id"] = $stateParams.CampaignId;
      }
    }

    function scheduleButtonToggle(value) {
      vm.selectTimezone();
      vm.stateScheduleCampaign = value;
      vm.scheduleRequired = true;
    }

    function typeOfAction(mode, draft) {
      if (mode == "edit") {
        if (draft === true) vm.updateDraft();
        else vm.updateCampaign();
      } else if (mode == "create" || mode == "replicate") {
        if (draft === true) vm.saveDraft();
        else vm.saveCampaign();
      }
    }

    function updateCampaign() {
      vm.queryPrepare(false);
      CampaignsService.updateCampaign(vm.query)
        .then(function(response) {
          vm.countFilter = response.data;
          $state.go("root.emails.campaignList");
        })
        .catch(function(err) {});
    }

    function confirmation() {
      vm.stateScheduleCampaign = false;
      vm.scheduleRequired = false;
      vm.sendDate = moment()
        .utc()
        .format("YYYY-MM-DD HH:mm:ss");
      vm.stateSendNowCampaign = true;
      $uibModal.open({
        templateUrl:
          "templates/emails/campaign/form/confirmationSendNow/template.modal.html",
        controller: "confirmationSendNowController",
        controllerAs: "confirmationSendNow",
        resolve: {
          campaignController: function() {
            return vm;
          }
        }
      });
    }

    function fillForm(id) {
      var query = [];
      var hash = Math.floor(Date.now() / 1000);
      query["id"] = id;
      CampaignsService.get(query)
        .then(function(response) {
          vm.form = response.data[0];
          $timeout(function() {
            if (vm.mode === "replicate") {
              vm.campaignName = vm.form.title + " - Copy " + hash;
            } else {
              vm.campaignName = vm.form.title;
            }
            vm.categorySelected = vm.categoryList.filter(function(obj) {
              return obj.id == vm.form.adm_email_category_id;
            })[0];
            vm.emailSubject = vm.form.subject;
            vm.fromName = vm.form.from_name;
            vm.replyToEmail = vm.form.reply_to;
            vm.fromEmail = vm.form.from;
            vm.campaignAssociatedSelected = vm.campaignAssociatedList.filter(
              function(obj) {
                return obj.alias == vm.form.campaign_associated_with;
              }
            )[0];
            vm.selectTour();
            /* TEMPLATE */
            vm.templateEmail = vm.form.template;
            /* AUDIENCE */
            vm.selectAudience().then(function(list) {
              vm.audienceList = list;
              vm.audienceSelected = vm.audienceList.filter(function(obj) {
                return obj.id == vm.form.audience_id;
              })[0];
            });
            /* FINISH */
            vm.stateScheduleCampaign = false;
            if (
              vm.form.timezone !== "0" &&
              vm.form.timezone !== "" &&
              typeof vm.form.timezone !== "undefined"
            ) {
              vm.stateScheduleCampaign = true;
              vm.selectTimezone().then(function(list) {
                vm.audienceList = list;
                vm.timezoneSelected = vm.timezoneList.filter(function(obj) {
                  return obj.name == vm.form.timezone;
                })[0];
              });
            }
            if (
              vm.form.sendDate !== "0000-00-00 00:00:00" &&
              typeof vm.form.sendDate !== "undefined"
            )
              vm.sendDate = vm.form.send_at;
            vm.timezoneSelected = vm.form.timezone;
            vm.edit = true;
          }, 0);
        })
        .catch(function(err) {});
    }

    function selectTimezone() {
      var defer = $q.defer();
      TimezoneService.getAll()
        .then(function(response) {
          vm.timezoneList = response.data;
          defer.resolve(response.data);
        })
        .catch(function(err) {
          defer.resolve(err);
        });
      return defer.promise;
    }

    function selectTour() {
      if (
        typeof vm.campaignAssociatedSelected !== "undefined" &&
        vm.campaignAssociatedSelected.id == 1
      ) {
        vm.selectPhysicalFair().then(function(list) {
          vm.tourList = list;
          if ($stateParams.CampaignId) {
            vm.tourSelected = vm.tourList.filter(function(obj) {
              return obj.id == vm.form.tour_id;
            })[0];
            vm.selectTourCity().then(function(list) {
              vm.tourCityList = list;
              vm.tourCitySelected = vm.tourCityList.filter(function(obj) {
                return obj.id == vm.form.tour_city_id;
              })[0];
            });
          }
        });
      } else if (
        typeof vm.campaignAssociatedSelected !== "undefined" &&
        vm.campaignAssociatedSelected.id == 2
      ) {
        vm.selectVirtualFair().then(function(list) {
          vm.tourList = list;
          if ($stateParams.CampaignId) {
            vm.tourSelected = vm.tourList.filter(function(obj) {
              return obj.id == vm.form.tour_id;
            })[0];
          }
        });
      }
    }

    function getAllCampaigns() {
      CampaignsService.getAllCampaigns()
        .then(function(response) {
          vm.countFilter = response.data.data;
        })
        .catch(function(err) {});
    }

    function selectTourCity() {
      if (vm.campaignAssociatedSelected.id === 1) {
        var defer = $q.defer();
        CitiesByExpoService.getCities(vm.tourSelected.id)
          .then(function(response) {
            vm.tourCityList = response.data;
            defer.resolve(response.data);
          })
          .catch(function(err) {
            defer.reject(err);
          });
        return defer.promise;
      }
    }

    function selectPhysicalFair() {
      var defer = $q.defer();
      ExpoService.getExpos()
        .then(function(response) {
          defer.resolve(response.data);
        })
        .catch(function(err) {
          defer.reject(err);
        });
      return defer.promise;
    }

    function selectVirtualFair() {
      var defer = $q.defer();
      ExpoService.getExposVirtualFair()
        .then(function(response) {
          defer.resolve(response.data);
        })
        .catch(function(err) {
          defer.reject(err);
        });
      return defer.promise;
    }

    function saveDraft() {
      vm.queryPrepare(true);
      CampaignsService.saveCampaign(vm.query)
        .then(function(response) {
          vm.countFilter = response.data;
          $state.go("root.emails.campaignList");
        })
        .catch(function(err) {});
    }

    function updateDraft() {
      vm.queryPrepare(true);
      CampaignsService.updateCampaign(vm.query)
        .then(function(response) {
          vm.countFilter = response.data;
          $state.go("root.emails.campaignList");
        })
        .catch(function(err) {});
    }

    function setPage(pageNo) {
      vm.currentPage = pageNo;
    }

    function pageChanged(pageNo) {
      vm.page = vm.currentPage;
      vm.saveCampaign();
    }

    function getTswUrl() {
      CampaignsService.getTswUrl()
        .then(function(response) {
          vm.tswUrl = response.data;
        })
        .catch(function(err) {});
    }

    activate();
  }
})();
